export default class Tracking {
  static event = (
    category,
    action,
    label = null,
    value = null,
    eventType = 'click',
    nonInteraction = false
  ) => {
    if (category && action) {
      if (window.document.documentMode) return;

      const eventValue = Number.isInteger(value) ? value : null;

      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: 'eventTracking',
          eventType,
          eventCategory: category,
          eventAction: action,
          eventLabel: label,
          eventValue,
          eventNonInteraction: nonInteraction
        });
      }
    }
  };

  static action = (category, action, label, value) => {
    Tracking.event(category, action, label, value, 'action', true);
  };

  static splitTest = () => {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({ event: 'optimize.activate' });
    }
  };

  static dataLayerPush = layer => {
    const layerData = JSON.parse(layer.push);
    const dataLayerObject = Object.assign({}, { eventType: layer.eventType || 'click' }, layerData);
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push(dataLayerObject);
    }
  };
}
